import React from 'react';

import useClassy from '@core/hooks/useClassy';

import Tooltip from '@ui/Tooltip';

import classes from './index.module.scss';

export default function BranchStatusIndicator({
  branchType = 'version',
  isMinimal,
}: {
  branchType?: 'branch' | 'version';
  isMinimal?: boolean;
}) {
  const bem = useClassy(classes, 'BranchStatusIndicator');
  return isMinimal && branchType === 'version' ? (
    <Tooltip asTitle content="Live and visible to your users" placement="bottom">
      <span aria-label="Live" className={bem('&', isMinimal && '_minimal')} />
    </Tooltip>
  ) : (
    <span className={bem('&', branchType === 'branch' && '_branch')}>
      {branchType === 'branch' ? 'Not Merged' : 'Live'}
    </span>
  );
}
